<template>
    <div>
           <nav class="level">
                     <div class="level-left">
                         
                         <div class="level-item">
                           <span class="mr-3">DVM</span> 
                            <b-autocomplete
                                v-model="dvmAutocompleteModelAutomate"
                                :data="filteredDVM"
                                placeholder="e.g. สมชาย"
                                icon="magnify"
                                :open-on-focus=true
                                clearable
                                field="full_name"
                                @input = "newTypingAutocompleteDVM"
                                @select="option => (dvmSelectedModelAutomate = option)"
                                >
                                 <template slot="empty">No results found </template>
                            </b-autocomplete>
                         </div>


                         <div class="level-item">
                           
                         </div>
                         <div class="level-item">
                            <span class="mr-3">Department</span>
                            <b-autocomplete
                                v-model="deptAutocompleteModelAutomate"
                                :data="filteredDept"
                                placeholder="e.g. 101 อายุรกรรมสัตว์ป่วยนอก"
                                icon="magnify"
                                :open-on-focus=true
                                clearable
                                field="name"
                                @input = "newTypingAutocompleteDept"
                                @select="option => (deptSelectedModelAutomate = option)"
                                >
                                 <template slot="empty">No results found </template>
                            </b-autocomplete>
                         </div>


                      


                     </div>
 
                     <div class="level-right ">
                        <div class="level-item has-text-grey">
                          จำนวน(รายการ) : <span class="is-size-5  has-text-info ml-3  ">    {{checkedRowsDetailAutomateModel.length}} </span>
                        </div>
                        <div class="level-item has-text-grey">
                          รวมราคา(บาท):  <span class="is-size-5 has-text-info  ml-3  ">   {{formatStringToCurrency(calculatePriceInCheckedRowsDetail)}}  </span>
                        </div>   
                        <div class="level-item">
                            <b-button 
                            type="is-info" 
                            :disabled="allowNext"
                            @click="itemsSelection"
                            >Next</b-button>
                        </div>    
                     </div>
                   
                 </nav>




        <div class="columns">
             <div class="column">
                 <b-table
                                    :data="isEmpty ? [] : getGroup"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    :loading="isTblLoading"
                                    :selected.sync="selectedGroup"
                                    mobile-cards>
                                <b-table-column   label="กลุ่ม"  v-slot="props"   >
                                   <span class="is-size-6">  {{ props.row.grp_name }}
                                   <span  class="tag is-success is-size-6"   v-if="grpSelectedAtleaseOne( props.row.idgrp)"> {{countItemsSelectedEachGroup( props.row.idgrp)}}</span>
                                   </span>
                                </b-table-column>
                </b-table>    
             </div>
             <div class="column is-two-thirds">
                <!-- {{getDetailGroup}} -->
                 <!-- { "id": 7, "idpart": "000000000007", "descp": "ตรวจ CBC ทั่วไป", "unit": "ครั้ง", "sell_price": 300, "idgrp": 3, "amount": 0 } , -->
                <b-table
                                    :data="isEmpty ? [] : getDetailGroup"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    checkable
                                     :checked-rows.sync="checkedRowsDetailAutomateModel"
                                    mobile-cards>

                                <b-table-column   label="รหัส"  v-slot="props" >
                                  {{ props.row.idpart }}
                                </b-table-column>
                                <b-table-column   label="รายการ"  v-slot="props" >
                                    {{ props.row.descp }}
                                </b-table-column>
                                <b-table-column   label="หน่วยนับ"  width="12%" v-slot="props" >
                                    {{ props.row.unit }}
                                </b-table-column>
                                <b-table-column   label="ราคาต่อหน่วย" width="12%" v-slot="props" >
                                    {{ formatStringToCurrency( props.row.sell_price ) }}
                                </b-table-column>

                                <b-table-column   label="จำนวน"  width="12%" v-slot="props" >
                                  <input type="number"
                                         min="1" 
                                         v-model="props.row.amount" 
                                         :disabled="itemIsSelected( props.row.id)"
                                         >  
                                </b-table-column>

                                 <b-table-column   label="ราคา(บาท)"  width="12%" v-slot="props" >
                                    {{  formatStringToCurrency( props.row.sell_price * props.row.amount )}}
                                </b-table-column>
                </b-table>  
             </div>
          </div>    




    </div>
</template>


<script>
import {  mapMutations, mapState  } from "vuex";
import formatStringToCurrency from '../../../mixins/methods/formatStringToCurrency'

export default {
    name : "AutomateItemsSelection",
    mixins:[formatStringToCurrency,],
    mounted(){
        if(this.dataGroupAndDetailAutomate.length>0){
           this.selectedGroup =this.dataGroupAndDetailAutomate[0]
          // console.log("mount AutomateItemsSelection")
        }
    },
    computed:{
            ...mapState({
                dataGroupAndDetailAutomate : state => state.patho_opd_job_worklist.dataGroupAndDetailAutomate ,


                automateOrNoneAutomateMode: state => state.patho_opd_job_worklist.automateOrNoneAutomateMode ,
                dvmArr : state => state.patho_opd_job_worklist.dvmArr ,
                deptArr : state => state.patho_opd_job_worklist.deptArr ,


                checkedRowsDetailAutomate : state => state.patho_opd_job_worklist.checkedRowsDetailAutomate ,
                dvmSelectedAutomate: state => state.patho_opd_job_worklist.dvmSelectedAutomate ,
                deptSelectedAutomate: state => state.patho_opd_job_worklist.deptSelectedAutomate , 
                dvmAutocompleteAutomate: state => state.patho_opd_job_worklist.dvmAutocompleteAutomate ,
                deptAutocompleteAutomate: state => state.patho_opd_job_worklist.deptAutocompleteAutomate , 
            }) ,


        checkedRowsDetailAutomateModel:{
                get: function () {
                    return this.checkedRowsDetailAutomate
                },
                set: function (newValue) {
                    this.setCheckedRowsDetailAutomate(newValue)
                }
        },    
        dvmAutocompleteModelAutomate:{
                get: function () {
                    return this.dvmAutocompleteAutomate
                },
                set: function (newValue) {
                    this.setDVMAutocompleteAutomate(newValue)
                }
        },  

        deptAutocompleteModelAutomate:{
                get: function () {
                    return this.deptAutocompleteAutomate
                },
                set: function (newValue) {
                    this.setDeptAutocompleteAutomate(newValue)
                }
        }, 


        dvmSelectedModelAutomate:{
                get: function () {
                    return this.dvmSelectedAutomate
                },
                set: function (newValue) {
                    this.setDVMSelectedAutomate(newValue)
                }
        },  
        
        
        deptSelectedModelAutomate:{
                get: function () {
                    return this.deptSelectedAutomate
                },
                set: function (newValue) {
                    this.setDeptSelectedAutomate(newValue)
                }
        },









        allowNext(){
           return     this.dvmSelectedModelAutomate == null || this.deptSelectedModelAutomate == null || this.checkedRowsDetailAutomateModel.length==0
        },    
        getGroup(){
          return    this.dataGroupAndDetailAutomate.map(dat=>{
                   return {
                    "idgrp" : dat.idgrp,
                    "grp_name" : dat.grp_name
                   }
          })
        },
        getDetailGroup(){
            if(this.selectedGroup !== null){
               const detail = this.dataGroupAndDetailAutomate.find(dat=>dat.idgrp == this.selectedGroup.idgrp )
               return detail.detail 
            }

            return []
            
        },
        getCountDetailSelection(){
            // const unique = [...new Set(data.map(item => item.group))]
            const tmp = []
            const unique = [...new Set(this.checkedRowsDetailAutomateModel.map(item => item.idgrp))]
            for(var i=0;i<=unique.length-1;i++){
              const tmpArr =  this.checkedRowsDetailAutomateModel.filter(dat=>dat.idgrp==unique[i])
              tmp.push({
                "idgrp" : unique[i],
                "count_selected" : tmpArr.length
              })
            }
            
            return tmp //example-> [ { "idgrp": 3, "count_selected": 1 }, { "idgrp": 4, "count_selected": 1 } ]
        },


        filteredDVM() {
                return this.dvmArr.filter((_dvm) => {
                     
                    return  _dvm.full_name
                            .toString()
                            // .indexOf(this.breedAutocomplete) >= 0
                            .toUpperCase()
                            .indexOf(this.dvmAutocompleteModelAutomate.toUpperCase()) >= 0
                })

        },
        filteredDept() {
                return this.deptArr.filter((_dept) => {
                     
                    return  _dept.name
                            .toString()
                            // .indexOf(this.breedAutocomplete) >= 0
                            .toUpperCase()
                            .indexOf(this.deptAutocompleteModelAutomate.toUpperCase()) >= 0
                })

        },
        calculatePriceInCheckedRowsDetail(){
            return  this.checkedRowsDetailAutomateModel.map(dat=>dat.sell_price*dat.amount)
                                          .reduce((acc,cur)=>acc+cur , 0) 
        }

    },
    methods:{
        ...mapMutations({
            setCheckedRowsDetailAutomate : 'patho_opd_job_worklist/setCheckedRowsDetailAutomate',
            setDVMSelectedAutomate: 'patho_opd_job_worklist/setDVMSelectedAutomate',
            setDeptSelectedAutomate  : 'patho_opd_job_worklist/setDeptSelectedAutomate',
            setDVMAutocompleteAutomate: 'patho_opd_job_worklist/setDVMAutocompleteAutomate',
            setDeptAutocompleteAutomate: 'patho_opd_job_worklist/setDeptAutocompleteAutomate',
        }),

        
        itemsSelection(){
           this.$emit('itemsSelected',this.checkedRowsDetailAutomateModel)
        }, 



        grpSelectedAtleaseOne(_idGrp){
            // console.log(_idGrp)
           return this.getCountDetailSelection.find(dat=> dat.idgrp == _idGrp)
        },
        countItemsSelectedEachGroup(_idGrp){
             
            return this.checkedRowsDetailAutomateModel.filter(dat=>dat.idgrp == _idGrp)
                                         .length
        },
        itemIsSelected(_id){
            // console.log(_id)
            // this.checkedRowsDetailAutomate.find(dat=>dat.id == _id) 
            return !this.checkedRowsDetailAutomateModel.find(dat=>dat.id == _id) 
        },
        newTypingAutocompleteDVM(){
                
                const memberDVM = this.dvmArr.find(memberDVM => memberDVM.full_name === this.dvmAutocompleteModelAutomate  )
               
                if(memberDVM){
                    this.dvmSelectedModelAutomate = memberDVM.iduser
                }else{
                    this.dvmSelectedModelAutomate = null
                }
         
        },

        newTypingAutocompleteDept(){
               
                const memberDept = this.deptArr.find(memberDept => memberDept.name === this.deptAutocompleteModelAutomate  )
               
                if(memberDept){
                    this.deptSelectedModelAutomate = memberDept.iddepartment
                }else{
                    this.deptSelectedModelAutomate = null
                }
         
        },
         
    },
    data(){
        return {
            isTblLoading : false,
            isEmpty : false,
            selectedGroup : null,
        }
    }
}
</script>